/**
 * Centros de Costo API Service
 */
import api from './api';

const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/contabilidad');
})();

const centrosCostoService = {
  getAll: (filters = {}) => api.get(`${API_BASE_URL}/centros-costo/`, { params: filters }),
  getById: (id) => api.get(`${API_BASE_URL}/centros-costo/${id}/`),
  create: (data) => api.post(`${API_BASE_URL}/centros-costo/`, data),
  update: (id, data) => api.patch(`${API_BASE_URL}/centros-costo/${id}/`, data),
  delete: (id) => api.delete(`${API_BASE_URL}/centros-costo/${id}/`),
  getTree: (id) => api.get(`${API_BASE_URL}/centros-costo/${id}/tree/`),
};

export default centrosCostoService;
